<span class="status-badge" [ngClass]="limited ? 'status-badge--danger' : 'status-badge--success'">
  {{ label }}
</span>
